const filepath = "imgs/2t5_2t6_pics/";
export default [
    {
        picture: filepath + "HarmitGoswami.webp",
        name: "Harmit Goswami",
        role: "Co-Chair",
        year: "2T5+PEY",
        contact: [
            "E-mail: harmit.goswami@mail.utoronto.ca",
            "Discord: harmitcrab",
            "Instagram: harmit.goswami"
        ]
    },
    {
        picture: filepath + "AvaJakob.webp",
        name: "Ava Jakob",
        role: "Co-Chair",
        year: "2T5+PEY",
        contact: [
            "E-mail: ava.jakob@mail.utoronto.ca",
            "Discord: avajakob",
            "Instagram: _ava_jakob"
        ]
    },
    {
        picture: filepath + "LavneetSidhu.webp",
        name: "Lavneet Sidhu",
        role: "Vice Chair",
        year: "2T7+PEY",
        contact: [
            "E-mail: lavneet.singh@mail.utoronto.ca",
            "Discord: la_la_la_",
            "Instagram: lavneetsidhu"
        ]
    },
    {
        picture: filepath + "placeholder.png",
        name: "Agrim Sharma",
        role: "Finance Director",
        year: "2T6+PEY",
        contact: [
            "E-mail: agrim.sharma@mail.utoronto.ca",
            "Discord: heyreaper",
            "Instagram: _agrim.s"
        ]
    },
    {
        picture: filepath + "CheickDoumbia.webp",
        name: "Cheick Doumbia",
        role: "Academic Director",
        year: "2T5+PEY",
        contact: [
            "E-mail: cheick.doumbia@mail.utoronto.ca",
            "Discord: yatrios",
            "Instagram: _cheickdoumbia"
        ]
    },
    {
        picture: filepath + "SelinaZarzour.webp",
        name: "Selina Zarzour",
        role: "Academic Director",
        year: "2T7+PEY",
        contact: [
            "E-mail: selina.zarzour@mail.utoronto.ca",
            "Discord: selina.zarzour",
            "Instagram: selinazarzour"
        ]
    },
    {
        picture: filepath + "placeholder.png",
        name: "Maria Hekimian",
        role: "Specialty Events Director",
        year: "2T5+PEY",
        contact: [
            "E-mail: maria.hekimian@mail.utoronto.ca",
            "Discord: maria.h6140",
            "Instagram: maria.hekimian"
        ]
    },
    {
        picture: filepath + "SehreenBasara.webp",
        name: "Sehreen Basara",
        role: "Specialty Events Director",
        year: "2T8",
        contact: [
            "E-mail: sehreen.basara@mail.utoronto.ca",
            "Discord: SehreenB",
            "Instagram: sbasarra"
        ]
    },
    {
        picture: filepath + "JasonMa.webp",
        name: "Jason Ma",
        role: "General Events Director",
        year: "2T8",
        contact: [
            "E-mail: yinghang.ma@mail.utoronto.ca",
            "Discord: kuroto3850",
            "Instagram: mjason0612"
        ]
    },
    {
        picture: filepath + "ZainNawaz.webp",
        name: "Zain Nawaz",
        role: "General Events Director",
        year: "2T8",
        contact: [
            "E-mail: zain.nawaz@mail.utoronto.ca",
            "Discord: zain523",
            "Instagram: zainn_523"
        ]
    },
    {
        picture: filepath + "YifeiChen.webp",
        name: "Yifei Chen",
        role: "Social Media Director",
        year: "2T8",
        contact: [
            "E-mail: cfy.chen@mail.utoronto.ca",
            "Discord: yifeichen0522",
            "Instagram: yifeichen046"
        ]
    },
    {
        picture: filepath + "placeholder.png",
        name: "Parth Bhambi",
        role: "Archivist",
        year: "2T8",
        contact: [
            "E-mail: parth.bhambi@mail.utoronto.ca",
            "Discord: parthology",
            "Instagram: parth.425"
        ]
    },
    {
        picture: filepath + "MatthewKong.webp",
        name: "Matthew Kong",
        role: "Webmaster",
        year: "2T8",
        contact: [
            "E-mail: matthew.kong@mail.utoronto.ca",
            "Discord: matthewkong",
            "Instagram: hynixcjr"
        ]
    },
    {
        picture: filepath + "JamesSheng.webp",
        name: "James Sheng",
        role: "Webmaster",
        year: "2T8",
        contact: [
            "E-mail: james.sheng@mail.utoronto.ca",
            "Discord: .ditsu",
            "Instagram: james._.kys"
        ]
    },
    {
        picture: filepath + "MohammedSuwan.webp",
        name: "Mohammed Suwan",
        role: "Mentorship Director",
        year: "2T7",
        contact: [
            "E-mail: mohammed.suwan@mail.utoronto.ca",
            "Discord: suwan8426",
            "Instagram: __suwan__"
        ]
    },
    {
        picture: filepath + "DuruTurkdonmez.webp",
        name: "Duru Turkdonmez",
        role: "Mentorship Director",
        year: "2T7+PEY",
        contact: [
            "E-mail: duru.turkdonmez@mail.utoronto.ca",
            "Discord: duruturkdonmez",
            "Instagram: duruturkdonmez"
        ]
    },
    {
        picture: filepath + "LilyKim.webp",
        name: "Lily Kim",
        role: "Apparel Director",
        year: "2T5+PEY",
        contact: [
            "E-mail: lilylily.kim@mail.utoronto.ca",
            "Discord: lilyy2206",
            "Instagram: jin_bbang319"
        ]
    },
    {
        picture: filepath + "JustinFang.webp",
        name: "Justin Fang",
        role: "Facilites Manager + EngSoc BoD",
        year: "2T7",
        contact: [
            "E-mail: justin.fang@mail.utoronto.ca",
            "Discord: 1771justin",
            "Instagram: 1771justin"
        ]
    },
    {
        picture: filepath + "placeholder.png",
        name: "Ayan Ali",
        role: "EngSoc BoD",
        year: "2T?",
        contact: []
    },
    {
        picture: filepath + "DaphneZhu.webp",
        name: "Daphne Zhu",
        role: "1st Year Class Rep",
        year: "2T9",
        contact: [
            "E-mail: daphne.zhu@mail.utoronto.ca",
            "Discord: daphneee0107",
            "Instagram: daphne_for_ece_class_rep"
        ]
    },
    {
        picture: filepath + "placeholder.png",
        name: "Shelley Lin",
        role: "1st Year Class Rep",
        year: "2T9",
        contact: [
            "E-mail: shelley.lin@mail.utoronto.ca",
            "Discord: sshelley",
            "Instagram: sshelley.lin"
        ]
    },
    {
        picture: filepath + "placeholder.png",
        name: "Sam Ghasemzadeh",
        role: "1st Year Class Rep",
        year: "2T9",
        contact: [
            "E-mail: sam.ghasemzadeh@mail.utoronto.ca",
            "Discord: sam._.ghz",
            "Instagram: its_samghz"
        ]
    },
    {
        picture: filepath + "JeffreyWong.webp",
        name: "Jeffrey Wong",
        role: "2nd Year Class Rep",
        year: "2T8",
        contact: []
    },
    {
        picture: filepath + "EthanMao.webp",
        name: "Ethan Mao",
        role: "2nd Year Class Rep",
        year: "2T8",
        contact: [
            "E-mail: ethan.mao@mail.utoronto.ca",
            "Discord: tabyelox",
            "Instagram: ethan_mao__"
        ]
    },
    {
        picture: filepath + "ArnavAgarwal.webp",
        name: "Arnav Agarwal",
        role: "2nd Year Class Rep",
        year: "2T8",
        contact: [
            "E-mail: aa.agarwal@mail.utoronto.ca",
            "Discord: arnav6252",
            "Instagram: arnyagarwal"
        ]
    },
    {
        picture: filepath + "AbdullahBinRashid.webp",
        name: "Abdullah Bin Rashid",
        role: "2nd Year Class Rep",
        year: "2T8",
        contact: [
            "E-mail: abdullah.rashid@mail.utoronto.ca",
            "Discord: xxxdaboss4409",
            "Instagram: a.bdullahrashid"
        ]
    },
    {
        picture: filepath + "placeholder.png",
        name: "Rashid Mahmood",
        role: "2nd Year Class Rep",
        year: "2T8",
        contact: [
            "E-mail: rashid.mahmood@mail.utoronto.ca",
            "Discord: pinkcloudylight",
            "Instagram: itzzrashidbro"
        ]
    },
    {
        picture: filepath + "VishwasPuri.webp",
        name: "Vishwas Puri",
        role: "3rd Year Class Rep",
        year: "2T7+PEY",
        contact: [
            "E-mail: vishwas.puri@mail.utoronto.ca",
            "Discord: vishwaspuri",
            "Instagram: vishwaspuri_official"
        ]
    },
    {
        picture: filepath + "placeholder.png",
        name: "Gia Bejar",
        role: "3rd Year Class Rep",
        year: "2T7+PEY",
        contact: [
            "E-mail: g.bejaralvarez@mail.utoronto.ca",
            "Discord: gbejar",
            "Instagram: gianella.bejar"
        ]
    },
    {
        picture: filepath + "FirdausAnsari.webp",
        name: "Firdaus Ansari",
        role: "3rd Year Class Rep",
        year: "2T7+PEY",
        contact: [
            "E-mail: firdaus.ansari@mail.utoronto.ca",
            "Discord: carameldude00",
            "Instagram: prince_fashah"
        ]
    },
    {
        picture: filepath + "JoeDai.webp",
        name: "Joe Dai",
        role: "PEY Class Rep",
        year: "2T6+PEY",
        contact: [
            "E-mail: jd.dai@mail.utoronto.ca",
            "Discord: jdtech",
            "Instagram: _joe.dai_"
        ]
    },
    {
        picture: filepath + "NidhiNair.webp",
        name: "Nidhi Nair",
        role: "4th Year Class Rep",
        year: "2T5+PEY",
        contact: [
            "E-mail: nidhi.nair@mail.utoronto.ca",
            "Discord: nidhinair23",
            "Instagram: nidhinair23"
        ]
    },
    {
        picture: filepath + "HannahLila.webp",
        name: "Hannah Lila",
        role: "4th Year Class Rep",
        year: "2T5+PEY",
        contact: [
            "E-mail: hannah.lila@mail.utoronto.ca",
            "Discord: hl6939",
            "Instagram: hhannahlila"
        ]
    },
    {
        picture: filepath + "AsimRahman.webp",
        name: "Asim Rahman",
        role: "4th Year Class Rep",
        year: "2T5+PEY",
        contact: [
            "E-mail: asim.rahman@mail.utoronto.ca",
            "Discord: asim.615",
            "Instagram: asim.rahman_"
        ]
    },
    {
        picture: filepath + "placeholder.png",
        name: "Raida Fardous",
        role: "4th Year Class Rep",
        year: "2T5+PEY",
        contact: [
            "E-mail: raida.fardous@mail.utoronto.ca",
            "Discord: rai7789",
            "Instagram: raida.f_"
        ]
    }
    
]